import React,{Component} from "react";
import arrowRight from "../../../../../assets/img/arrowRight.png";
import FormFieldValidationError from "../../../../Common/FormFieldValidationError/FormFieldValidationError";

class TraceWidth extends Component {

    constructor(props,context) {
        super(props, context);
        this.state = {

            width: "",
            widthError: ""
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.validateTraceWidth = this.validateTraceWidth.bind(this);

    }

    validateTraceWidth = () => {
        let width = this.state.width;
        return (width !== "");
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            widthError: ""
        });
    };

    onClick = event => {

        event.preventDefault();

        let widthError = "";
        let validationPassed = true;

        if (!this.validateTraceWidth(event)) {
            validationPassed = false;
            widthError = "app.validation.width.invalid-value";
        }

        if (validationPassed) {
            this.props.setImpedanceValueToPreview(this.state.width)

        } else {

            this.setState({widthError});
        }
    };

    render() {
        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="pcb-details-div">
                        <div className="col-md-3 text-right calc-item-heading">
                            Trace Width
                            &nbsp; &nbsp;
                        </div>

                        <div className="col-md-5 impedance-div-items">
                            <input className="form-control trace-select"
                                   name="width"
                                   value={this.state.width}
                                   onChange={this.onInputChange}/>
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.widthError}/>
                            </div>
                        </div>
                        <div className="col-md-1 arrow-img">
                            <input type="image" src={arrowRight} alt="Submit" onClick={this.onClick}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TraceWidth;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/CustomizationFormFields/TraceWidth.js